import { FC } from 'react';
import { Button, } from '@mui/material';

interface ContactUsProps {
  title: string;
}

const ContactUsButton: FC<React.PropsWithChildren<ContactUsProps>> = (props) => {
  return (
        <Button
            color="primary"
            href="https://iotec.io/contact-us"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              justifyContent: 'flex-start',
              py: 2,
              textTransform: 'none',
              width: '100%'
            }}
            variant="text"
        >
            {props.title}
        </Button>
  );
};

export default ContactUsButton;
